import { useTheme } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import {
  SIGNUP_FORM_INIT_VALUES,
  SIGNUP_MAX_CHARS,
} from '../../constants/auth';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { Copy } from '../../copy/Copy';
import { useAuth } from '../../hooks/useAuth/useAuth';
import {
  marginTop16Sx,
  buttonSx,
  centerText16pxMarginSx,
} from '../../styles/Global.style';
import { Form } from '../Form/Form';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { SIGNUP_VALIDATION_SCHEMA } from '../../validation/auth';
import { HelperLink } from '../HelperLink/HelperLink';
import { Password } from '../Password/Password';
import { handleRegisterErrMessage } from '../../helpers/handleRegisterErrMessage';
import { PrivacyCheckbox } from '../PrivacyCheckbox/PrivacyCheckbox';
import { disabledButtonSx } from './RegistrationForm.style';

export const RegistrationForm = ({ handleRegister }) => {
  const theme = useTheme();
  const { signUp } = useAuth();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  const handleCheckboxChange = () => {
    setIsSubmitDisabled(!isSubmitDisabled);
  };

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: SIGNUP_FORM_INIT_VALUES,
    validationSchema: SIGNUP_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await signUp(
          val.email.toLowerCase(),
          val.password,
          val.firstName,
          val.lastName,
        );
        handleRegister(val.email.toLowerCase());
      } catch (err) {
        setIsError(true);
        setMessage(handleRegisterErrMessage(err.message));
        resetError();
      }
    },
  });

  return (
    <FormContainer title={Copy.generate('Global.register')}>
      <Form formik={formik} isError={isError} message={message}>
        <FormInput
          inputFor="firstName"
          formik={formik}
          labelText={Copy.generate('Inputs.firstName')}
          inputType="text"
          inputProps={SIGNUP_MAX_CHARS}
        />

        <FormInput
          inputFor="lastName"
          formik={formik}
          labelText={Copy.generate('Inputs.lastName')}
          inputType="text"
          inputProps={SIGNUP_MAX_CHARS}
        />

        <FormInput
          inputFor="email"
          formik={formik}
          labelText={Copy.generate('Inputs.email')}
          inputType="email"
        />

        <Password formik={formik} />

        <PrivacyCheckbox onChange={handleCheckboxChange} />

        <Button
          type="submit"
          fullWidth
          text={Copy.generate('Global.signUp')}
          sx={{
            ...buttonSx(theme),
            ...disabledButtonSx(theme),
            ...marginTop16Sx,
          }}
          disabled={isSubmitDisabled}
        />
      </Form>

      {!isError && (
        <HelperLink
          to="#"
          textIdentifier="Links.verify"
          linkText={Copy.generate('Global.verify')}
          onClick={() => handleRegister(null)}
          sx={centerText16pxMarginSx}
        />
      )}
    </FormContainer>
  );
};
